var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"category-promo"},[_c('router-link',{attrs:{"to":{name: 'category', params: {slug: _vm.category.slug}}}},[_c('div',{staticClass:"template-container"},[_c('div',[(_vm.promoTemplate)?_c('app-card',{attrs:{"template":_vm.promoTemplate,"bookLike":true,"static":""}}):_vm._e()],1)]),_c('h3',[_vm._v(_vm._s(_vm.category.name))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }